
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SectionHeader',
  props: {
    title: {
      type: String,
      required: true
    }
  },
  computed: {
    headingId(): string {
      return `section-heading-${this.title.toLowerCase().replace(/\s+/g, '-')}`
    }
  }
})
